import React from 'react'
import { Link } from "react-router-dom";
import About from './About'
import ScrollToTop from "react-scroll-to-top";
import Header from '../inc/Header';
import Profile from './Profile';
function Aboutus() {
  return (
    <div>
        <Header/>
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
        
              <div className='newback'>
                <div className="album py-1">
        
                  <div className="container  mt-3">
        
                    <nav aria-label="breadcrumb">
                      <ol className="breadcrumb">
                        <li className="breadcrumb-item"><Link to="/" >Home</Link></li>
                        <li className="breadcrumb-item active" aria-current="page">About us</li>
                      </ol>
                    </nav>
                  </div>
                </div>
              </div>
        <ScrollToTop smooth top="100" color="grey"/>
        <About/>
        <Profile/>
    </div>
  )
}

export default Aboutus